var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.enlace,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(_vm.texto)+" "),_c('span',{staticClass:"icono-enlace-externo",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }